import { Stack, Typography } from "@mui/material";
import { MarketoIcon } from "../images";

export const MarketoLabel = () => {
  return (
    <Stack flexDirection={"row"} gap={"6px"} alignItems={"center"}>
      <MarketoIcon />
      <Typography
        variant="body1"
        color={"custom.textDarkBlue"}
        sx={{ color: "#232323", fontWeight: 500 }}
      >
        Marketo
      </Typography>
    </Stack>
  );
};
